export default __webpack_public_path__ + "static/media/analytics_testseriesM.e090755c.png";